<div class="padding-box ">
    <form [formGroup]="model" (ngSubmit)="submit()">
        <div class="container orientations-session">

            <div class="section-title">
                <h3 [ngStyle]="{'color': colorCode}">Informe sua data de nascimento!</h3>
            </div>
            <div class="col-md-12">
                <mat-form-field appearance="outline">
                    <mat-label>Data de Nascimento: </mat-label>
                    <input matInput [mask]="masks.date" type="text" formControlName="birthDate">
                    <mat-error
                        *ngIf="model.get('birthDate').invalid && model.get('birthDate').errors && !model.get('birthDate').errors.invalidDate">Data
                        é obrigatória</mat-error>
                    <mat-error
                        *ngIf="model.get('birthDate').invalid && model.get('birthDate').errors && model.get('birthDate').errors.invalidDate">{{model.get('birthDate').errors.invalidDate}}</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="button-container">
            <button mat-flat-button color="primary" type="submit" class="button-go">
                <span>Confirmar</span>
            </button>
        </div>
    </form>
</div>